import type { AccountBase } from '@/models/AccountViewModel';

export type AccountInvestor = NonNullable<AccountBase['Investors']>[number];

export const investorName = (investor: AccountInvestor): string =>
  investor.InvestorName?.trim() || investor.Name?.trim() || '';

export const linkableAccountInvestors = (
  investors: AccountBase['Investors'],
): AccountInvestor[] =>
  (investors ?? [])
    // DB rows are inconsistent — an Investors array can contain null entries.
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    .filter((investor) => investor?.InvestorId != null)
    .filter((investor) => investorName(investor).length > 0)
    .sort((a, b) => investorName(a).localeCompare(investorName(b)));
